<style scope>
/* #my-table th {
  background-color: #f9f9f9;
  text-align: center !important;
  vertical-align: middle !important;
} */

#my-table thead tr th {
  border-width: 2px !important;
}

#my-table thead tr th.border-0 {
  background-color: hsl(0, 0%, 100%) !important;
}

#my-table thead tr th {
  background-color: hsl(0, 0%, 95%) !important;
}

</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body pb-0">
            <form action="" class="" @submit.prevent="validateForm" novalidate>
              <div class="row d-flex align-items-end">
                <FormInput name="ContractPolicyNumber" type="text" label="กรมธรรม์" v-model="values.ContractPolicyNumber"
                  placeholder="กรมธรรม์" @validate="validate" :error="errors.ContractPolicyNumber"
                  formGroupClass="form-group col-lg-3 col-md-6" />

                <FormInput name="InsuranceId" type="select" label="บริษัทประกัน" v-model="values.InsuranceId"
                  placeholder="บริษัทประกัน" :require-field="false" @validate="validate"
                  :option-datas="MasterInsuranceComp" :error="errors.InsuranceComp"
                  formGroupClass="form-group col-lg-3 col-md-6" />

                <FormInput name="Firstname" type="text" label="ชื่อ" v-model="values.Firstname" placeholder="ชื่อ"
                  @validate="validate" :error="errors.Firstname" formGroupClass="form-group col-lg-3 col-md-6" />
                <FormInput name="Lastname" type="text" label="นามสกุล" v-model="values.Lastname" placeholder="นามสกุล"
                  @validate="validate" :error="errors.Lastname" formGroupClass="form-group col-lg-3 col-md-6" />


              </div>
              <div class="row d-flex align-items-endx">

                <div class="form-group mb-0 col-lg-6 col-md-6">
                  <FormInput id="DueDateIn" name="DueDateIn" type="radio" label="ครบกำหนดชำระภายใน"
                    v-model="values.DueDateIn" placeholder="ครบกำหนดชำระภายใน" @validate="validate"
                    :option-datas="MasterDueDateIn" :error="errors.DueDateIn" formGroupClass="ml-2" />
                </div>

                <div class="col-lg-6 col-md-6 text-right">
                  <div class="form-group">
                    <button type="submit" class="btn btn-primary" :disabled="isDownload"
                      v-show="checkPermission(['ReadJob'])">
                      <i class="fe-search"></i>
                      ค้นหา
                      <div v-show="isDownload" class="spinner-border spinner-border-sm ml-2" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-group col-12 text-info"><u>
                หมายเหตุ : ข้อมูลในส่วนนี้ อาจยังไม่ปรากฏข้อมูลของบางบริษัท เช่น กรุงไทยแอกซ่า ฯลฯ
                หากต้องการข้อมูลเพิ่มเติม โปรดติดต่อเจ้าหน้าที่สาขาที่ท่านดูแล
              </u>
              </div>

            </form>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body pb-0">
            <!-- <label for="dvLoading" class="pt-1">ผลการตรวจสอบ</label> -->
            <!-- <div id="dvLoading" v-show="isDownload" class="spinner-border spinner-border-sm ml-2" role="status">
                  <span class="sr-only">Loading...</span>
                </div> -->
            <!-- :filter="checkFilter"  -->
            <!-- Table -->
            <b-table id="my-table" ref="table" class="table table-centered table-striped borders mt-2"
              :filter="checkFilter" :fields="fields" :items="getDataTable" :per-page="values.PerPage"
              :current-page="values.CurrentPage" :busy="isDownload" small>

              <template #head(ContractPolicyNumber)="data">
                <span>{{ data.label }}</span>
              </template>

              <template #head(InsuranceComp)="data">
                <span>{{ data.label }}</span>
              </template>

              <template #cell(ContractPolicyNumber)="data">
                <span :class="{ 'text-danger': $dayjs(data.item.NextDueDate).isBefore($dayjs(), 'day') }">
                  {{ data.item.ContractPolicyNumber }}</span>
              </template>
              <template #cell(InsuranceComp)="data">
                <span :class="{ 'text-danger': $dayjs(data.item.NextDueDate).isBefore($dayjs(), 'day') }">
                  {{ data.item.InsuranceComp }}</span>
              </template>
              <template #cell(NextDueDate)="data">
                <span :class="{ 'text-danger': $dayjs(data.item.NextDueDate).isBefore($dayjs(), 'day') }">
                  {{ dateFormat(data.item.NextDueDate) }}</span>
              </template>
              <template #cell(Year)="data">
                <span :class="{ 'text-danger': $dayjs(data.item.NextDueDate).isBefore($dayjs(), 'day') }">
                  {{ data.item.Year }}</span>
              </template>
              <template #cell(Period)="data">
                <span :class="{ 'text-danger': $dayjs(data.item.NextDueDate).isBefore($dayjs(), 'day') }">
                  {{ data.item.Period }}</span>
              </template>
              <template #cell(Premium)="data">
                <span :class="{ 'text-danger': $dayjs(data.item.NextDueDate).isBefore($dayjs(), 'day') }">
                  {{ moneyFormatFull(data.item.Premium) }}</span>
              </template>
              <!-- <template #cell(SKLCustomerName)="data">
                <span :class="{ 'text-danger': data.item.SKLCustomerName != data.item.INSCustomerName }">{{
                  data.item.SKLCustomerName }}</span>
              </template> -->
              <template #cell(INSCustomerName)="data">
                <span :class="{ 'text-danger': $dayjs(data.item.NextDueDate).isBefore($dayjs(), 'day') }">
                  {{ data.item.INSCustomerName }}</span>
              </template>
              <!-- <template #cell(SKLProductName)="data">
                <span :class="{ 'text-danger': data.item.SKLProductName != data.item.INSProductName }">{{
                  data.item.SKLProductName }}</span>
              </template> -->
              <template #cell(INSProductName)="data">
                <span :class="{ 'text-danger': $dayjs(data.item.NextDueDate).isBefore($dayjs(), 'day') }">
                  {{ data.item.INSProductName }}</span>
              </template>

              <!-- <template v-slot:cell(actions)="row">
                <button class="btn btn-info btn-sm" @click="onClickShowDetail(row.item)"><i
                    class="fe-search"></i></button>
                <router-link :to="{ name: 'job-edit', params: { slug: row.item.Id } }"
                  class="btn btn-secondary btn-sm ml-1">
                  ดูใบคำขอ
                </router-link>

              </template> -->
            </b-table>
            <b-pagination v-model="values.CurrentPage" :total-rows="TotalRows" :per-page="values.PerPage"
              aria-controls="my-table"></b-pagination>
            <!-- end table -->
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

<script>

import Layout from '@/components/layouts/main'
import PageHeader from '@/components/page-header'

let self;
export default {
  page: {
    title: 'ตรวจสอบงานปีต่อกับ บริษัทประกัน',
    meta: [{ name: 'description' }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    var yup = this.yup
    return {
      title: 'ตรวจสอบงานปีต่อกับ บริษัทประกัน',
      items: [
        {
          text: 'SKLife',
          to: { name: 'home' }
        },
        {
          text: 'Job',
          to: { name: 'job-list' }
        },
        {
          text: 'Check Renew',
          active: true,
        },
      ],
      isDownload: false,
      checkFilter: '1',
      TotalRows: 0,
      dataList: [],
      MasterInsuranceComp: [],
      MasterDueDateIn: [
        { id: '60', value: '60 วัน' },
        { id: '30', value: '30 วัน' },
        { id: '10', value: '10 วัน' },
        { id: '-365', value: 'เกินกำหนด' },
        { id: '', value: 'ทั้งหมด' },
      ],
      VUE_APP_OFFICEAPI_URL: process.env.VUE_APP_OFFICEAPI_URL,
      values: {
        ContractPolicyNumber: '',
        Firstname: '',
        Lastname: '',
        DueDateIn: '',
        DateStart: this.$dayjs().format('YYYY-MM-DD'),
        DateEnd: this.$dayjs().format('YYYY-MM-DD'),
        InsuranceId: '',
        PerPage: 10,
        CurrentPage: 1,
      },
      errors: {
        ContractPolicyNumber: '',
        Firstname: '',
        Lastname: '',
        DueDateIn: '',
        DateStart: "",
        DateEnd: "",
        InsuranceId: '',
      },
      FormSchema: yup.object().shape({
        ContractPolicyNumber: yup.string().nullable(),
        Firstname: yup.string().nullable(),
        Lastname: yup.string().nullable(),
        DueDateIn: yup.string().nullable(),
        DateStart: yup.string().nullable().required(),
        DateEnd: yup.string().nullable().required(),
        InsuranceId: yup.string().nullable(),
      }),
      fields: [
        {
          key: 'ContractPolicyNumber', label: 'กรมธรรม์', sortable: false, class: 'border',
          formatter: (value, key, item) => {
            return item.ContractPolicyNumber
          }
        },
        {
          key: 'InsuranceComp', label: 'บริษัท', sortable: false, class: 'border',
          formatter: (value, key, item) => {
            return item.InsuranceComp
          }
        },
        // {
        //   key: 'SKLCustomerName', label: 'ชื่อ-นามสกุล (SKL)', class: 'border color-sys',
        //   formatter: (value, key, item) => {
        //     return item.SKLCustomerName;
        //   }
        // },
        {
          key: 'INSCustomerName', label: 'ชื่อ-นามสกุล', sortable: false, class: 'border',
          formatter: (value, key, item) => {
            return item.INSCustomerName;
          }
        },
        // {
        //   key: 'SKLProductName', label: 'แบบประกัน (SKL)', sortable: false, class: 'border color-sys',
        //   formatter: (value, key, item) => {
        //     return item.SKLProductName;
        //   }
        // },
        {
          key: 'INSProductName', label: 'แบบประกัน', sortable: false, class: 'border',
          formatter: (value, key, item) => {
            return item.INSProductName;
          }
        },
        {
          key: 'NextDueDate', label: 'ครบกำหนดชำระ', sortable: false, class: 'border text-center',
          formatter: (value, key, item) => {
            if (value == null)
              return '';
            else
              return self.dateFormat(value)
          }
        },
        {
          key: 'Year', label: 'ปี', sortable: false, class: 'border text-center',
          formatter: (value, key, item) => {
            return value;
          }
        },
        {
          key: 'Period', label: 'งวด', sortable: false, class: 'border text-center',
          formatter: (value, key, item) => {
            return value;
          }
        },
        {
          key: 'Premium', label: 'เบี้ยที่ต้องชำระ', sortable: false, class: 'text-right border',
          formatter: (value, key, item) => {
            return self.moneyFormatFull(value)
          }
        },
        // {
        //   key: 'Branch', label: 'สาขา', sortable: false, class: 'border',
        //   formatter: (value, key, item) => {
        //     return value
        //   }
        // },
      ],
    }
  },
  async created() {
    self = this;
    //self.MasterInsuranceComp = self.$store.state.Insurances.map((c) => { return { id: c.Id, value: c.FullName } });
    self.getInsurance();
    //await self.getMasterData();
  },
  watch: {
    'values.branchTeam': {
      handler: function () {

        self.values.branch = 9999;
        self.dataMasterBranchOptions = self.dataMasterBranch.filter(c => c.BranchTeamId == self.values.branchTeam || self.values.branchTeam == 9999).map((c) => {
          return {
            id: c.Id,
            value: c.Name
          }
        });
        self.dataMasterBranchOptions = [{ id: 9999, value: 'ทั้งหมด' }, ...self.dataMasterBranchOptions];
        console.log('Change teaM')
      }
    }
  },
  mounted() {
    let startDate = this.$dayjs().format('YYYY-MM-01');
    let endDate = this.$dayjs().endOf('month').format('YYYY-MM-DD');
    this.values.DateStart = startDate;
    this.values.DateEnd = endDate;
    console.log(this.values.DateStart)
  },
  methods: {
    validateForm() {
      this.FormSchema
        .validate(this.values, { abortEarly: false })
        .then(() => {
          self.checkFilter = this.$dayjs();
          console.log('Loading...')
        })
        .catch(err => {
          console.log('no download')
          err.inner.forEach(error => {
            this.errors = { ...this.errors, [error.path]: error.message };
          });
        });
    },
    validate(field) {
      this.FormSchema
        .validateAt(field, this.values)
        .then(() => {
          this.errors[field] = "";
        })
        .catch(err => {
          this.errors[err.path] = err.message;
        });
    },

    async getInsurance() {
      this.isBusy = true
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` },
      };
      await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/center/getinsurance', config)
        .then(function (res) {
          if (res.status == 200) {
            self.MasterInsuranceComp = res.data.map((c) => { return { id: c.Id, value: c.FullName } });
          } else {
            self.$swal('เกิดข้อผิดพลาด');
          }
          self.isBusy = false
        })
        .catch(function (error) {
          self.$swal('เกิดข้อผิดพลาด');
          self.isBusy = false
        });
    },

    // downloadExcel(values) {
    //   try {
    //     self.isDownload = true;
    //     const config = {
    //       headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
    //       responseType: 'blob',
    //       params: values
    //     };
    //     this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/report/getreward', config)
    //       .then(function (res) {
    //         if (res.status == 200) {
    //           const filename = 'RewardReport_' + self.values.DateStart + '_to_' + self.values.DateEnd + '.xlsx';
    //           self.saveAs(res.data, filename);
    //         } else {
    //           self.$swal('เกิดข้อผิดพลาด1');
    //         }
    //         self.isDownload = false;
    //       })
    //       .catch(function (error) {
    //         self.$swal('เกิดข้อผิดพลาด2');
    //         self.isDownload = false;
    //       });
    //   } catch (error) {
    //     return null
    //   }
    // },

    async getDataTable(ctx) {
      try {
        self.isDownload = true;
        const config = {
          headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
          params: self.values
        };

        const response = await self.axios.get(process.env.VUE_APP_OFFICEAPI_URL + `/api/order/getorderrenew`, config)
        self.isDownload = false;
        console.log(response.data, response.data.length)
        self.TotalRows = response.data.TotalRecords;
        return response.data.Data
      } catch (error) {
        self.isDownload = false;
        return []
      }
    },

  },
}
</script>

